import Immutable from "immutable";

export function activeInDevFeaturesFromLocalStorage(features) {
    return {type: "ACTIVE_IN_DEV_FEATURES", payload: {source: "LOCAL", features}};
}

export function activeInDevFeaturesFromSessionStorage(features) {
    return {type: "ACTIVE_IN_DEV_FEATURES", payload: {source: "SESSION", features}};
}

export function activeInDevFeaturesFromLocation(features) {
    return {type: "ACTIVE_IN_DEV_FEATURES", payload: {source: "LOCATION", features}};
}

export function activeInDevFeaturesFromCookie(features) {
    return {type: "ACTIVE_IN_DEV_FEATURES", payload: {source: "COOKIE", features}};
}

export function reducer(state = Immutable.Map(), action) {
    switch (action.type) {
        case "ACTIVE_IN_DEV_FEATURES":
            const {source, features} = action.payload;
            return state.set(source, Immutable.Set(features));
        default:
            return state;
    }
}
